import React from 'react'
import Img from 'gatsby-image'
import ReactPlayer from 'react-player/lazy'

const FullTemplateTwo = ({ data }) => {
    const { 
        media, 
        title, 
        content, 
        contentGroup, 
        image1, 
        image2 
    } = data

    return (
        <section className="full-template-two">
            <div className="left col">
                {media && (
                    <div className="media-wrapper">
                        <ReactPlayer 
                            url={media}
                            className='react-player'
                            width='100%'
                            height='100%'
                            controls={true}
                        />
                    </div>
                )}
                <div className="content-container">
                    {contentGroup.title && (
                        <h3 className="col-title">{contentGroup.title}</h3>
                    )}
                    { contentGroup.listItem ? contentGroup.listItem.map((item, i) => {
                        return (
                            <div key={i} className="content-row">
                                { item.icon && (
                                    <div className="icon-wrapper">
                                        <Img 
                                            fixed={item.icon?.localFile?.childImageSharp?.fixed}
                                        />
                                    </div>
                                )}
                                <div className="content">
                                    {item.title && (
                                        <p className="title">{item.title}</p>
                                    )}
                                    {item.content && (
                                        <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                                    )}
                                </div>
                            </div>
                        )
                    }) : null }
                </div>
            </div>
            <div className="right col">
                <div className="content">
                    {title && (
                        <h5>{title}</h5>
                    )}
                    {content && (
                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                    )}
                </div>
                <div className="image-wrapper">
                    {image1 && (
                        <Img 
                            fluid={image1?.localFile?.childImageSharp?.fluid}
                        />
                    )}
                </div>
                <div className="image-wrapper">
                    {image2 && (
                        <Img 
                            fluid={image2?.localFile?.childImageSharp?.fluid}
                        />
                    )}
                </div>
            </div>
        </section>
    )
}

export default FullTemplateTwo
